<template>
  <AppLayout>
    <div class="inventor" style="padding-bottom: 50px !important;">
    <section id="suppliers-add">
      <div class="container">
        <h6 class="fw-bold" style="color: black !important">
          <button v-if="batchId" class="btn-default btn btn-sm pull-right" style="margin-top: 0px;float:right; border: 1px solid #000;" @click="splitBatchModal()">Split Receipt</button>
          <button v-if="purchase" class="btn-default btn btn-sm pull-right" style="margin-top: 0px;float:right; border: 1px solid #000;margin-right: 15px;"  @click="this.$router.push('/purchases/pdf/'+purchase.id)">View PO</button>
        </h6>
        <div class="row mt-4">
          <h6 class="col-md-2 fw-bold" >1. Delivery Details</h6>
          <h6 class="col-md-10 fw-bold" v-if="!isInternal">2. Courier & Supplier Details</h6>
        </div>
        <div>
          <div class="form">
            <div class="row">
              <div class="col-md-1">
                  <div class="check-button">
                  <div class="form-group">
                      <label>Internal Delivery?</label>
                      <div class="components-button">
                  <span class="switcher switcher-1">
                      <input type="checkbox" id="switcher-1" v-model="isInternal">
                      <label for="switcher-1"></label>
                  </span>
                      </div>
                  </div>
                  </div>
              </div>
              <div class="col-md-1" v-if="!isInternal"></div>
              <div class="col-md-2" v-if="isInternal">
                <div class="form-group">
                  <label for="driver">Select Driver</label>
                  <select v-model="driverId" class="full" id="driver"  v-if="users.length > 0">
                      <option v-for="user in users" v-bind:Key="user.id" :value="user.id">
                          {{ user.name }}
                      </option>
                  </select>
                </div>
              </div>
              <div class="col-md-2" v-if="isInternal">
                <div class="form-group">
                  <label for="internal-vehicle">Select Vehicle</label>
                  <select v-if="vehicles.length > 0" v-model="vehicleId" class="full" id="internal-vehicle" @change="syncVehicleSelection">
                    <option value="">Select vehicle</option>
                    <option v-for="v in vehicles" :key="v.id" :value="v.id">
                      {{ v.plateNumber }}{{ v.make || v.model ? ` — ${(v.make || '')} ${(v.model || '')}` : '' }}
                    </option>
                  </select>
                  <input v-else type="text" class="form-control" v-model="vehicle" placeholder="Vehicle Reg No.">
                </div>
              </div>
              <div class="col-md-2" v-if="!isInternal">
                <div class="form-group">
                  <label for="suppliers">Select Supplier</label>
                  <select v-model="supplierId" class="full" id="suppliers" :disabled="purchaseId != null" v-if="suppliers.length > 0">
                      <option v-for="supplier in suppliers" v-bind:Key="supplier.id" :value="supplier.id">
                          {{ supplier.name }}
                      </option>
                  </select>
                </div>
              </div>
              <div class="col-md-2" v-if="!isInternal">
                <div class="form-group">
                  <label for="address">Driver's Name</label>
                  <input type="text" v-model="driver" id="address" class="form-control">
                </div>
              </div>
              <div class="col-md-2" v-if="!isInternal">
                <div class="form-group">
                  <label for="item-code">Contacts</label>
                  <input type="text" class="form-control" id="item-code" v-model="contacts">
                </div>
              </div>
              <div class="col-md-2" v-if="!isInternal">
                <div class="form-group">
                  <label for="item-code">Vehicle Reg No.</label>
                  <input type="text" class="form-control" id="item-code" v-model="vehicle">
                </div>
              </div>
            </div>

            <div class="row">
              <h6 class="col-md-5 fw-bold">2. Stock Description</h6>
              <h6 class="col-md-7 fw-bold">3. Consignment Details & Documents</h6>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Stock Category</label>
                  <template v-if="isLoadingPurchaseData && purchaseId">
                    <div class="skeleton-input"></div>
                  </template>
                  <template v-else-if="nogs.length > 0">
                    <select v-model="nogId" class="full" id="stockCategories">
                      <option v-for="nog in nogs" v-bind:Key="nog.id" :value="nog.id">
                          {{ nog.nog }}
                      </option>
                    </select>
                  </template>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="item-code">BPN Tags</label>
                  <template v-if="isLoadingPurchaseData && purchaseId">
                    <div class="skeleton-input"></div>
                  </template>
                  <template v-else-if="tags.length > 0">
                    <select v-model="tagId" class="full" id="suppliers">
                      <option v-for="tag in tags" v-bind:Key="tag.id" :value="tag.id">
                          {{ tag.tag }}
                      </option>
                    </select>
                  </template>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Project / Site</label>
                  <template v-if="isLoadingPurchaseData && purchaseId">
                    <div class="skeleton-input"></div>
                  </template>
                  <template v-else-if="projectOptions.length > 0">
                    <Select2 
                      class="select2" 
                      :class="{ 'select2-disabled': purchaseId != null }"
                      style="width: 100% !important;" 
                      v-model="project" 
                      :options="projectOptions" 
                      :settings="{ width: 'resolve', selectionCssClass: ':all:', placeholder: 'Search Project...' }" 
                      :disabled="purchaseId != null" 
                    />
                  </template>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="item-code">PO No.</label>
                  <Select2 class="select2" v-if="purchaseOptions.length > 0" style="width: 100% !important;" v-model="purchaseId" :options="purchaseOptions" :settings="{ width: 'resolve', selectionCssClass: ':all:', placeholder: 'Search PO...' }" />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Reference 1</label>
                  <template v-if="isLoadingPurchaseData && purchaseId">
                    <div class="skeleton-input"></div>
                  </template>
                  <template v-else>
                    <input type="text" class="form-control" id="item-code" v-model="reference1">
                  </template>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="item-code">Reference 2</label>
                  <template v-if="isLoadingPurchaseData && purchaseId">
                    <div class="skeleton-input"></div>
                  </template>
                  <template v-else>
                    <input type="text" class="form-control" id="item-code" v-model="reference2">
                  </template>
                </div>
              </div>

              <div class="col-md-12 mt-2">
                <label class="fw-bold">Supporting Documents</label>
                <div
                  v-for="(row, idx) in documentAttachments"
                  :key="'doc-att-' + idx"
                  class="row align-items-end mb-2"
                >
                  <div class="col-md-3">
                    <div class="form-group">
                      <label>Document type</label>
                      <select v-model="row.documentType" class="full">
                        <option v-for="doc in documentTypes" :value="doc.name" :key="doc.id">{{ doc.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Upload</label>
                      <input type="file" class="form-control" accept=".pdf,.jpg,.jpeg,.png" @change="onAttachmentFile(idx, $event)">
                    </div>
                  </div>
                  <div class="col-md-3 d-flex gap-2 align-items-center pb-2">
                    <button type="button" class="btn btn-sm btn-outline-secondary" @click="addAttachmentRow">+ Add document</button>
                    <button v-if="documentAttachments.length > 1" type="button" class="btn btn-sm btn-outline-danger" @click="removeAttachmentRow(idx)">Remove</button>
                  </div>
                </div>
              </div>

              <div class="col-md-2 mt-4">
                <!--<button v-if="batchId == '' && !purchaseId" class="btn-style" @click="postBatch" :disabled="isCreatingBatch">-->
                <button v-if="batchId == ''" class="btn-style" @click="postBatch" :disabled="isCreatingBatch">
                    <span v-if="isCreatingBatch">
                      Creating Batch
                      <img src="../../../assets/images/loader.gif" style="width: 20px; margin-left: 5px"/>
                    </span>
                  <span v-else>Add Batch</span>
                </button>
              </div>
            
            </div>

          </div>
        </div>
        <div v-if="purchase && purchaseItemsReady"  style="margin-top:30px;">
          <h6 class="fw-bold">3. Purchase Order Items</h6>
            <table class="table table-hover">
                <thead>
                  <th>No.</th>
                  <th>Product Description</th>
                  <th>Unit</th>
                  <th>Qty</th>
                  <th>Qty Fulfilled</th>
                  <th>Qty Received</th>
                      <th>Price</th>
                      <th>Amount</th>
                      <th>Condition</th>
                  <th>Comments</th>
                  <th>Action</th>
                </thead>
              <tbody v-if="purchase.PurchaseProduct?.length > 0">
                    <tr v-for="(item, index) in purchase?.PurchaseProduct" v-bind:key="item.id"
                      :class="{ 'fulfilled-row': (item.remainingQuantity ?? item.quantity) <= 0 }">
                      <td>{{ (index+1) }}</td>
                      <td>{{ item.Product?.name }}</td>
                      <td>{{ item.Product?.unit?.unit }}</td>
                      <td>{{ item?.quantity }}</td>
                      <td>{{ item.alreadyReceived ?? 0 }}</td>
                      <td>
                        <input class="form-control" type="number" min="0" :id="`quantity${item.id}`" v-model.number="item.receivedQuantity" :max="item.remainingQuantity ?? item.quantity" @input="onReceivedQtyChange(item)" :disabled="(item.remainingQuantity ?? item.quantity) <= 0" />
                        <small v-if="(item.remainingQuantity ?? item.quantity) <= 0" class="text-muted"></small>
                      </td>
                      <td>
                        <input class="form-control" type="number" step="0.01" min="0" :id="`price${item.id}`" v-model.number="item.price" @input="recalcAmount(item)" :disabled="(item.remainingQuantity ?? item.quantity) <= 0" />
                      </td>
                      <td>
                        <input class="form-control" type="number" step="0.01" min="0" :id="`amount${item.id}`" :value="item.receivedAmount ?? (Number(item.price || 0) * Number(item.receivedQuantity || 0)).toFixed(2)" disabled />
                      </td>
                      <td>
                          <select :id="`condition${item.id}`" class="full" :disabled="(item.remainingQuantity ?? item.quantity) <= 0">
                              <option value="New">New</option>
                              <option value="Used">Used</option>
                          </select>
                      </td>
                      <td><input class="form-control" type="text" :id="`comment${item.id}`" :disabled="(item.remainingQuantity ?? item.quantity) <= 0"/></td>
                      <td>
                          <button class="btn btn-primary btn-sm" 
                            :class="{ 'btn-success': isItemCompleted(item.id) }"
                            style="border:1px solid black;" 
                            :id="`button${item.id}`" 
                            @click="completeItem(item.id, item.Product?.id)"
                            :disabled="isCompletingItem !== null || isItemCompleted(item.id) || (item.remainingQuantity ?? item.quantity) <= 0">
                            <span v-if="isCompletingItem === item.id">
                              Completing
                              <img src="../../../assets/images/loader.gif" style="width: 20px; margin-left: 5px"/>
                            </span>
                            <span v-else-if="isItemCompleted(item.id)">Completed</span>
                            <span v-else>Complete</span>
                          </button>
                      </td>
                  </tr>
              </tbody>
              <!--
              <div v-else>
                <label for="" class="text-danger" style="margin: 0px auto; width: fit-content; text-align: center; display: block;">No items found</label>
              </div>
              -->
              
          </table>
          
          <div class="mb-5">
            <button class="btn-style small" style="border: 1px solid black; float: right;" @click="isVisible =true" :disabled="!canProcess">
              <span v-if="!canProcess" class="text-muted">Process (complete at least one item)</span>
              <span v-else>Process</span>
            </button>
            <!-- <button class="btn btn-success" style="float: right; margin-right: 10px;" @click="this.$router.push('/transaction')">Save</button>-->
            <button class="btn btn-default" style="border: 1px solid black; float: right; margin-right: 10px;" @click="cancelBatchAlert">Cancel</button>
          </div>
        </div>
        <div v-else-if="purchase && !purchaseItemsReady" style="margin-top:30px;">
          <h6 class="fw-bold">3. Purchase Order Items</h6>
          <div class="skeleton-loader">
            <div class="skeleton-header">
              <div class="skeleton-cell" style="width: 5%"></div>
              <div class="skeleton-cell" style="width: 20%"></div>
              <div class="skeleton-cell" style="width: 10%"></div>
              <div class="skeleton-cell" style="width: 8%"></div>
              <div class="skeleton-cell" style="width: 12%"></div>
              <div class="skeleton-cell" style="width: 12%"></div>
              <div class="skeleton-cell" style="width: 10%"></div>
              <div class="skeleton-cell" style="width: 10%"></div>
            </div>
            <div class="skeleton-row" v-for="i in 3" :key="i">
              <div class="skeleton-cell" style="width: 5%"></div>
              <div class="skeleton-cell" style="width: 20%"></div>
              <div class="skeleton-cell" style="width: 10%"></div>
              <div class="skeleton-cell" style="width: 8%"></div>
              <div class="skeleton-cell" style="width: 12%"></div>
              <div class="skeleton-cell" style="width: 12%"></div>
              <div class="skeleton-cell" style="width: 10%"></div>
              <div class="skeleton-cell" style="width: 10%"></div>
            </div>
          </div>
        </div>

        <div v-if="!purchase" :style="{ 'display': displayItems }" style="margin-top:30px;">
          <h6 class="fw-bold">3. Add Items</h6>
          <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label for="supplierContact">Product Description</label>
                  <Select2 class="select2" v-if="products.length > 0" style="width: 100% !important;" v-model="productId" :options="productOptions" :settings="{ width: 'resolve', selectionCssClass: ':all:' }" />
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Unit</label>
                  <input class="form-control"  type="text" v-model="itemUnit" />
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Quantity</label>
                  <input class="form-control" type="number" min="0" v-model.number="quantity" />
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Price</label>
                  <input class="form-control" type="number" step="0.01" min="0" v-model.number="price"/>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Amount</label>
                  <input class="form-control" type="number" step="0.01" min="0" :value="itemAmount" disabled />
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Condition</label>
                  <select v-model="condition"  class="full" >
                    <option value="New">New</option>
                    <option value="Used">Used</option>
                  </select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="supplierContact">Comments</label>
                  <input class="form-control" type="text" v-model="comment"/>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="supplierContact">Warehouse</label>
                  <select v-model="warehouseId" class="full" id="warehouses"  v-if="warehouses.length > 0">
                      <option v-for="warehouse in warehouses" v-bind:Key="warehouse.id" :value="warehouse.id">
                          {{ warehouse.name }} <span v-if="warehouse.isVirtual == true"> - {{ warehouse.description }}</span>
                      </option>
                  </select>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <label for="supplierContact">Section</label>                  
                  <select v-model="sectionId" class="full" id="sections">
                    <option v-for="section in sections" v-bind:Key="section.id" :value="section.id">
                        {{ section.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-1">
                <div class="form-group">
                  <button class="btn-style small" style="margin-top: 25px" @click="postItem">Add</button>
                </div>
              </div>

          </div>
            <table class="table table-hover">
              <thead>
                  <th>No.</th>
                  <th>Product Description</th>
                  <th>Unit</th>
                  <th>Qty</th>
                  <th>Price (KES)</th>
                  <th>Condition</th>
                  <th>Location</th>
                  <th>Comments</th>
                  <th>Action</th>
              </thead>
              <tbody v-if="items.length > 0">
                  <tr v-for="(item, index) in items" v-bind:key="item.id">
                      <td>{{ (index+1) }}</td>
                      <td>{{ item.Product.name }}</td>
                      <td>{{ item.Product?.unit?.unit }}</td>
                      <td>{{ item.quantity }}</td>
                      <td>{{ formatMoney(item.price) }}</td>
                      <td>{{ item.condition }}</td>
                      <td>{{ item.Warehouse?.name }}</td>
                      <td>{{ item.comment }}</td>
                      <td>
                          <button class="btn btn-default btn-sm" style="border:1px solid black;" @click="removeItem(item.id)">Remove</button>
                      </td>
                  </tr>
              </tbody>
              <div v-else>
                <label for="" class="text-danger mt-2" style="margin: 0px; width: fit-content; display: block;">No items found</label>
              </div>
          </table>

          <div>
            <button class="btn-style small" style="margin-bottom: 20px; border: 1px solid black; float: right;" @click="isVisible =true" :disabled="!canProcess">
              <span v-if="!canProcess" class="text-muted">Process (add at least one item)</span>
              <span v-else>Process</span>
            </button>
            <!--<button class="btn btn-success" style="margin-bottom: 20px; float: right; margin-right: 10px;" @click="this.$router.push('/transaction')">Save</button>-->
            <button class="btn btn-default" style="margin-bottom: 20px; border: 1px solid black; float: right; margin-right: 10px;" @click="cancelBatchAlert">Cancel</button>
          </div>
        </div>
      </div>
    </section>

<div v-if="isVisible" class="svc-modal-overlay" @click.self="isVisible = false">
  <div class="svc-modal-box">
    <div class="svc-modal-header">
      <h6 class="fw-bold mb-0">Confirm Stock Entry</h6>
      <button class="btn-close-plain" @click="isVisible = false" :disabled="isProcessing">&times;</button>
    </div>
    <div class="svc-modal-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label>Entered stock has been physically verified by you?</label>
            <div class="components-button">
              <span class="switcher switcher-1">
                <input type="checkbox" id="switcher-verified" v-model="isVerified" :disabled="isProcessing">
                <label for="switcher-verified"></label>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <label for="item-code">Assigned stock to guardian?</label>
          <div class="check-button">
            <div class="form-group">
              <div class="components-button">
                <span class="switcher switcher-1">
                  <input type="checkbox" id="switcher-guardian" v-model="isGuardian" :disabled="isProcessing">
                  <label for="switcher-guardian"></label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isGuardian" class="row mt-3">
        <div class="col-md-12">
          <label for="guardians">Guardian</label>
          <select v-model="guardianId" class="form-control form-control-sm" id="guardians" :disabled="isProcessing" v-if="users.length > 0">
            <option value="">Select Guardian</option>
            <option v-for="user in users" v-bind:key="user.id" :value="user.id">
              {{ user.name }}
            </option>
          </select>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-12">
          <label for="item-code">BPN Note</label>
          <input type="text" class="form-control form-control-sm" placeholder="Enter note regarding the stock batch" v-model="note" :disabled="isProcessing">
        </div>
      </div>
    </div>
    <div class="svc-modal-footer">
      <button class="btn btn-sm btn-style-2" @click="isVisible = false" :disabled="isProcessing">Cancel</button>
      <button class="btn btn-sm btn-primary" @click="processBatch" :disabled="isProcessing || !canProcess">
        <span v-if="isProcessing">
          Processing
          <img src="../../../assets/images/loader.gif" style="width: 15px; margin-left: 5px"/>
        </span>
        <span v-else-if="!canProcess">Process (complete at least one item)</span>
        <span v-else>Process</span>
      </button>
    </div>
  </div>
</div>

<div v-if="isVisiblePO" class="svc-modal-overlay" @click.self="isVisiblePO = false">
  <div class="svc-modal-box" style="max-width:480px;">
    <div class="svc-modal-header">
      <h6 class="fw-bold mb-0">Select warehouse and section</h6>
      <button class="btn-close-plain" @click="isVisiblePO = false" :disabled="isCompletingItem !== null">&times;</button>
    </div>
    <div class="svc-modal-body">
      <div class="row g-2">
        <div class="col-md-12">
          <label class="form-label" style="font-size:11px;">Warehouse</label>     
          <select class="form-control form-control-sm" v-model="poWarehouseId" v-if="warehouses.length > 0" :disabled="isCompletingItem !== null">
            <option v-for="warehouse in warehouses" v-bind:Key="warehouse.id" :value="warehouse.id">
              {{ warehouse.name }} <span v-if="warehouse.isVirtual == true"> - {{ warehouse.description }}</span>
            </option>
          </select>
        </div>
        <div class="col-md-12">
          <label class="form-label" style="font-size:11px;">Section</label>                  
          <select v-model="poSectionId" class="form-control form-control-sm" :disabled="isCompletingItem !== null">
            <option v-for="section in sections" v-bind:Key="section.id" :value="section.id">
              {{ section.name }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="svc-modal-footer">
      <button class="btn btn-sm btn-style-2" @click="isVisiblePO = false" :disabled="isCompletingItem !== null">Cancel</button>
      <button class="btn btn-sm btn-primary complete-item-btn" @click="postCompleteItem" :disabled="isCompletingItem !== null">
        <span v-if="isCompletingItem !== null" class="loader-text">
          <div class="horizontal-loader"></div>
          Completing...
        </span>
        <span v-else>Complete Item</span>
      </button>
    </div>
  </div>
</div>
</div>
</AppLayout>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import Swal from 'sweetalert2'

import AppLayout from '../../../components/AppLayout.vue';
import axios from 'axios'
import { ref } from 'vue';
import Select2 from 'vue3-select2-component';

export default {
  name: 'AddBatchPage',
  components: {
    AppLayout,
    Select2,
  },
  data: () => ({
      token: JSON.parse(localStorage.getItem('access_token')),
      items: [],
      sections: [],
      products: [],
      productOptions:[],
      purchaseOptions:[],
      projectOptions:[],
      displayItems: "none",
      displayGuardian: "block",
      DriverDisplay: "block",
      SupplierDisplay: "block",
      purchase:"",
      purchaseItemsReady: false,
      batchId: "",
      isVisible:false,
      isVisiblePO: false,
      dynamicValue : ref(0),
      isInternal: true,
      stockCategory: "",
      driverId: "",
      driver: "",
      contacts: "",
      vehicle: "",
      vehicleId: "",
      vehicles: [],
      project: "",
      documentAttachments: [{ documentType: '', file: null }],
      reference1: "",
      reference2: "",
      nogId: "",
      tagId: 0,
      warehouseId: "",
      sectionId: "",
      supplierId: null,
      purchaseId: null,
      productId: "",
      quantity: "",
      price: "",
      condition: "",
      comment: "",
      batchNo: "",
      itemUnit: "",
      itemSubUnit: "",
      itemNog: "",
      isVerified: true,
      isGuardian: true,
      guardianId: "",
      note: "",
      poSectionId:"",
      poWarehouseId:"",
      poQuantity:"",
      poPrice:"",
      poCondition:"",
      poComment:"",
      poProductId:"",
      poItemId:"",
      isCreatingBatch: false,
      isCompletingItem: null,
      isProcessing: false,
      isLoadingPurchaseData: false,
      completedItems: [],
  }),
  computed:{
      ... mapGetters (["getSuppliers", "getUsers", "getNogs", "getPurchases", "getPurchasenos", "getWarehouses", "getTags", "getProjects", "getDocumentTypes"]),
      suppliers () { return this.getSuppliers },
      users () { return this.getUsers },
      nogs () { return this.getNogs },
      purchases () { return this.getPurchases },
      purchasenos () { return this.getPurchasenos },
      purchasenosFiltered () {
        const list = (this.purchasenos || []).filter(p => (p.canBeFulfilled === true && p.status !== 'fulfilled') || p.status === 'partial');
        const seen = new Set();
        const unique = [];
        for (const p of list) {
          const key = String(p.purchaseNo || p.id || '');
          if (!seen.has(key)) {
            seen.add(key);
            unique.push(p);
          }
        }
        return unique;
      },
      warehouses () { return this.getWarehouses },
      tags () { return this.getTags },
      projects () { return this.getProjects},
      documentTypes () { return this.getDocumentTypes },
      itemAmount() {
        const q = Number(this.quantity) || 0
        const p = Number(this.price) || 0
        return parseFloat((q * p).toFixed(2))
      },
      canProcess() {
        // For purchase-linked batches require at least one completed PO item.
        // For non-purchase batches require at least one added item.
        if (this.purchase) {
          return (this.completedItems || []).length > 0;
        }
        return (this.items || []).length > 0;
      },
  },
  mounted(){
      this.fetchSuppliers(),
      this.fetchUsers(),
      this.fetchPurchases(),
      this.fetchPurchasenos(),
      this.fetchWarehouses(),
      this.fetchTags(),
      this.fetchNogs(),
      this.setupProducts(),
      this.fetchProjects(),
      this.fetchDocumentTypes(),
      this.loadVehicles()
      
      // Setup options after a short delay to ensure data is loaded
      setTimeout(() => {
        this.setupPurchaseOptions()
        this.setupProjectOptions()
      }, 500)

  },
  methods:{
      ... mapActions(['fetchSuppliers','fetchUsers', 'fetchNogs', 'fetchPurchases','fetchPurchasenos','fetchWarehouses','fetchTags', 'fetchProjects', 'fetchDocumentTypes']),
      statusLabel(status) {
        if (!status) return 'Unknown'
        const s = status.toString().toLowerCase()
        if (s === 'ceo_stamped' || s === 'ceo-stamped' || s === 'ceo stamped') return 'CEO Approved'
        if (s === 'stamped' || s === 'finance_stamped' || s.includes('stamped')) return 'Finance Approved'
        if (s === 'partial' || s === 'partially' || s === 'partially_fulfilled' || s === 'partially-fulfilled') return 'Partial Receipt'
        return status.toString()
      },
      async setupProducts(){
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/products', requestOptions)
        this.products = await res.json()
        this.productOptions = [];
        this.productOptions.push({ id: 0, text: "All"})
        this.products.forEach(product => {
          this.productOptions.push({ id: product.id, text: product.name})
        });
      },
      async loadVehicles() {
        try {
          const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token },
          }
          const res = await fetch(process.env.VUE_APP_URL + '/vehicles?page=1&limit=200', requestOptions)
          const data = await res.json()
          this.vehicles = Array.isArray(data?.data) ? data.data : []
        } catch (error) {
          this.vehicles = []
        }
      },
      syncVehicleSelection() {
        const selected = (this.vehicles || []).find(v => Number(v.id) === Number(this.vehicleId))
        if (selected?.plateNumber) {
          this.vehicle = selected.plateNumber
        } else if (this.isInternal) {
          this.vehicle = ''
        }
      },
      setupPurchaseOptions(){
        console.log('setupPurchaseOptions called with purchasenos:', this.purchasenos)
        this.purchaseOptions = [];
        this.purchaseOptions.push({ id: null, text: 'None' })
        if (this.purchasenos && this.purchasenos.length > 0) {
          this.purchasenosFiltered.forEach(po => {
            this.purchaseOptions.push({ 
              id: po.id, 
              text: `${po.purchaseNo} — ${this.statusLabel(po.status)}`
            })
          });
        }
        console.log('purchaseOptions setup complete:', this.purchaseOptions)
      },
      setupProjectOptions(){
        console.log('setupProjectOptions called with projects:', this.projects)
        this.projectOptions = [];
        this.projectOptions.push({ id: '', text: 'None' })
        if (this.projects && this.projects.length > 0) {
          this.projects.forEach(proj => {
            this.projectOptions.push({ 
              id: proj.name, 
              text: proj.name
            })
          });
        }
        console.log('projectOptions setup complete:', this.projectOptions)
      },
      closeModal() {
        this.isVisible = false;
      },
      closeModalPO() {
        this.isVisiblePO = false;
      },
      async processBatch () {
          if(this.batchId == "") {
            Swal.fire({
                icon: 'error',
                title: 'Batch not Found',
                text: "Try again or create a new batch"
            })
            return false;
          }

          if (!this.canProcess) {
            Swal.fire({ icon: 'error', title: 'Cannot Process', text: 'Complete at least one item before processing the batch.' });
            return false;
          }

          this.isProcessing = true
          try {
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
                body: JSON.stringify({ 
                  batchId: this.batchId,
                  isVerified: this.isVerified,
                  isGuardian: this.isGuardian,
                  guardianId: this.guardianId,
                  note: this.note,
                })
            };
            const res = await fetch(process.env.VUE_APP_URL+'/batches/process', requestOptions)
            const data = await res.json()
            if(data.status == true){
                Swal.fire({
                  position: 'top-center',
                  icon: 'success',
                  title: 'Batch Processed',
                  showConfirmButton: false,
                  timer: 1500
                })  
                this.$router.push('/transaction')         
            }else{
                Swal.fire({
                    icon: 'error',
                    title: 'Batch not Processed',
                    text: data.message
                })
            }
          } catch (err) {
            console.error(err)
            Swal.fire({ icon: 'error', title: 'Error', text: err.message || 'An error occurred' })
          } finally {
            this.isProcessing = false
          }
      },
      cancelBatchAlert(){
          Swal.fire({
            title: 'Confirm Batch Cancellation',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, cancel it!'
          }).then((result) => {
            if (result.isConfirmed) {
              this.cancelBatch();
            }
          })
      },
      async cancelBatch () {
          const requestOptions = {
              method: "GET",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
          };
          const res = await fetch(process.env.VUE_APP_URL+'/batches/cancel/'+this.batchId, requestOptions)
          const data = await res.json()
          if(data.status == true){
              Swal.fire({
                position: 'top-center',
                icon: 'success',
                title: 'Batch Cancelled',
                showConfirmButton: false,
                timer: 1500
              })
              this.$router.push('/transaction')          
          }else{
              Swal.fire({
                  icon: 'error',
                  title: 'Batch Cancellation Failed',
                  text: data.message
              })
          }
      },
      splitBatchModal(){
        Swal.fire({
          title: 'Confirm',
          text: "Kindly confirm that you want to split receipt.",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#000000',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirm'
        }).then((result) => {
          if (result.isConfirmed) {
            this.splitBatch()
          }
        })
      },
      async splitBatch(){
        const requestOptions = {
          method: "GET",
          headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/batches/split/'+this.batchId, requestOptions)
        const data = await res.json()
        if(data.status == true){
            Swal.fire({
              position: 'top-center',
              icon: 'success',
              title: 'Batch Splitted',
              showConfirmButton: false,
              timer: 1500
            })       
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Batch Split Failed',
                text: data.message
            })
        }
      },
      async removeItem (itemId) {
          const requestOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
              body: JSON.stringify({ 
                  itemId: itemId,
                  batchId: this.batchId,
              })
          };
          const res = await fetch(process.env.VUE_APP_URL+'/batches/items/delete', requestOptions)
          const data = await res.json()
          if(data.status == true){
              this.items = data.items
          }else{
              Swal.fire({
                  icon: 'error',
                  title: 'Batch Item not found',
                  text: data.message
              })
          }
      },
      addAttachmentRow () {
        this.documentAttachments.push({ documentType: '', file: null })
      },
      removeAttachmentRow (idx) {
        if (this.documentAttachments.length > 1) {
          this.documentAttachments.splice(idx, 1)
        }
      },
      onAttachmentFile (idx, e) {
        const f = e.target.files && e.target.files[0]
        if (this.documentAttachments[idx]) {
          this.documentAttachments[idx].file = f || null
        }
      },
      async postBatch () {
        this.isCreatingBatch = true;
        try {
          const types = this.documentAttachments.map((a) => a.documentType).filter(Boolean)
          const files = this.documentAttachments.map((a) => a.file).filter(Boolean)
          const primaryDoc = types[0] || ''

          let formData = new FormData()
          formData.append("name", this.name)
          formData.append("isInternal", this.isInternal)
          formData.append("driverId", this.driverId)
          const selectedVehicle = this.isInternal
            ? (this.vehicles || []).find(v => Number(v.id) === Number(this.vehicleId))
            : null
          const resolvedVehicle = selectedVehicle?.plateNumber || this.vehicle

          formData.append("driver", this.driver)
          formData.append("contacts", this.contacts)
          formData.append("vehicle", resolvedVehicle)
          formData.append("vehicleId", this.vehicleId || '')
          formData.append("project", this.project)
          formData.append("document", primaryDoc)
          if (types.length) {
            formData.append("documentTypes", JSON.stringify(types))
          }
          formData.append("reference1", this.reference1)
          formData.append("reference2", this.reference2)
          for (let i = 0; i < files.length; i++) {
            formData.append("files", files[i])
          }
          formData.append("nogId", this.nogId)
          formData.append("tagId", this.tagId)
          formData.append("supplierId", this.supplierId)
          formData.append("purchaseId", this.purchaseId)

          const response = await axios.post(process.env.VUE_APP_URL+'/batches', formData, {
            headers:{ 
              "Content-Type": "multipart/form-data", 
              'Authorization': 'Bearer '+this.token 
            }})
          if (response.data.status === true) {
            this.batchId = response.data.batch.id
            this.purchase = response.data.purchase
            this.displayItems = "block"
            this.setupPurchase()
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Batch not created',
              text: response.data.message
            })
          }
        } finally {
          this.isCreatingBatch = false;
        }
      },
      async postItem () {
          const requestOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
                body: JSON.stringify({ 
                  productId: this.productId,
                  batchId: this.batchId,
                  quantity: this.quantity,
                  price: String(this.price),
                  condition: this.condition,
                  comment: this.comment,
                  batchNo: this.batchNo,
                  warehouseId: this.warehouseId,
                  sectionId: this.sectionId,
                })
          };
          const res = await fetch(process.env.VUE_APP_URL+'/batches/items', requestOptions)
          const data = await res.json()
          if(data.status == true){
              this.items = data.items
              this.displayItems = "block"
              this.quantity = ""
              this.price = ""
              this.condition = "new"
              this.comment = ""
          }else{
              Swal.fire({
                  icon: 'error',
                  title: 'Batch Item not created',
                  text: data.message
              })
          }
      },

      async setupPurchase(){
            console.log('setupPurchase called with purchaseId:', this.purchaseId)
            if (!this.purchaseId) {
              console.log('setupPurchase: purchaseId is empty, returning')
              return
            }
            const requestOptions = {
                method: "GET",
                headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            };

            try{
              // mark not ready while we fetch and compute
              this.purchaseItemsReady = false;
              this.isLoadingPurchaseData = true;
              const apiUrl = process.env.VUE_APP_URL+'/purchases/'+this.purchaseId
              console.log('setupPurchase: Fetching from API URL:', apiUrl)
              const res = await fetch(apiUrl, requestOptions)
              console.log('setupPurchase: API Response status:', res.status, 'ok:', res.ok)
              const data = await res.json()
              console.log('setupPurchase: API Response data:', data)
              if(data.status == true){
                  this.purchase = data.purchase;
                  console.log("setupPurchase - Full response:", data)
                  console.log("setupPurchase - Purchase object:", this.purchase)
                  
                  // Try to set project immediately after receiving purchase data
                  if (this.purchase?.project) {
                    console.log('Setting project from setupPurchase:', this.purchase.project)
                    this.project = this.purchase.project
                  }
                  
                  // Set supplier from purchase
                  if (this.purchase?.supplierId) {
                    console.log('Setting supplier from setupPurchase:', this.purchase.supplierId)
                    this.supplierId = this.purchase.supplierId
                  }
                  
                  // Toggle internal delivery to No when purchase is loaded
                  this.isInternal = false
                  console.log('Internal delivery toggled to false')
                  
                  // initialize per-item helpers: store original unit price and receivedQuantity
                  // fetch related batches for this purchase. Backend now returns per-PP items
                  // with `alreadyReceived` and `remainingQuantity` when available.
                  const relatedBatches = await this.fetchBatchesForPurchase(this.purchaseId);
                  // backend shape: [{ items: [...] }] where items contain id/productId/alreadyReceived/remainingQuantity
                  const backendItems = (relatedBatches && relatedBatches.length > 0 && Array.isArray(relatedBatches[0].items)) ? relatedBatches[0].items : null;

                  (this.purchase.PurchaseProduct || []).forEach(it => {
                    const orderedQty = Number(it.quantity) || 0;
                    const rawPrice = Number(it.price) || 0;
                    let unit = Number(it.unitPrice) || 0;
                    if (!unit) {
                      // prefer backend price as unit price; fallback to total/qty when necessary
                      if (rawPrice >= 1) unit = rawPrice;
                      else if (orderedQty > 0) unit = rawPrice / orderedQty;
                    }
                    it.unitPrice = unit;

                    if (backendItems) {
                      // prefer exact match by purchaseProduct id, fallback to productId
                      const match = backendItems.find(bi => Number(bi.id) === Number(it.id) || Number(bi.purchaseProductId) === Number(it.id) || Number(bi.productId) === Number(it.productId));
                      if (match) {
                        // backend provides authoritative alreadyReceived/remainingQuantity
                        it.alreadyReceived = Number(match.alreadyReceived ?? match.receivedQuantity ?? match.quantity ?? 0);
                        it.remainingQuantity = Number(match.remainingQuantity ?? Math.max(0, orderedQty - (match.quantity ?? 0)));
                        it.receivedQuantity = it.remainingQuantity;
                        // store unit price separately and compute received amount
                        it.price = parseFloat(unit.toFixed(2));
                        it.receivedAmount = parseFloat((unit * (Number(it.receivedQuantity) || 0)).toFixed(2));
                        return; // next item
                      }
                    }

                    // fallback: compute from returned batch items (older shape)
                    const alreadyReceived = (relatedBatches || []).reduce((acc, b) => {
                      const items = b.items || [];
                      const matchingByPP = items.find(x => Number(x.purchaseProductId) === Number(it.id));
                      if (matchingByPP) return acc + (Number(matchingByPP.quantity) || 0);
                      const matchingByProduct = items.find(x => Number(x.productId) === Number(it.productId) || Number(x.productId) === Number(it.Product?.id));
                      if (matchingByProduct) return acc + (Number(matchingByProduct.quantity) || 0);
                      return acc;
                    }, 0);
                    it.alreadyReceived = alreadyReceived;
                    const remaining = Math.max(0, orderedQty - alreadyReceived);
                    it.remainingQuantity = remaining;
                    it.receivedQuantity = remaining;
                    it.price = parseFloat(unit.toFixed(2));
                    it.receivedAmount = parseFloat((unit * (Number(it.receivedQuantity) || 0)).toFixed(2));
                  })
                  console.log("Purchase", this.purchase)
                  console.log("Purchase Product",this.purchase.PurchaseProduct)
                  // ready to render purchase items with prefilled values
                  console.log('setupPurchase: Setting purchaseItemsReady to true')
                  this.purchaseItemsReady = true;
                  this.isLoadingPurchaseData = false;
              }else{
                console.log("setupPurchase: Error fetching purchase, data.status:", data.status, "message:", data.message || "Unknown error")
                this.purchaseItemsReady = false;
                this.isLoadingPurchaseData = false;
              }
            }catch(err){
              console.error('setupPurchase: Exception caught:', err, err.stack)
              this.purchaseItemsReady = false;
              this.isLoadingPurchaseData = false;
            }
            
      },

      async fetchBatchesForPurchase(purchaseId){
        if(!purchaseId) return [];
        const headers = { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token };
        try {
          const res = await fetch(process.env.VUE_APP_URL+`/batches/purchase/${purchaseId}/items`, { method: 'GET', headers });
          if(!res.ok) return [];
            const data = await res.json();
            // new endpoint format: { status: true, purchaseId, items: [...] }
            if (data && Array.isArray(data.items)) return [{ items: data.items }];
            // otherwise return empty; we rely on the backend contract for stability
            return [];
        } catch (e) {
          return [];
        }
      },

      async completeItem (itemId, productId) {
        // prefer reading values from the item object (keeps input-driven updates consistent)
        // addBatch

        const item = (this.purchase?.PurchaseProduct || []).find(p => p.id === itemId) || null;
        if (item) {
          // clamp poQuantity to remainingQuantity to prevent processing already-fulfilled qty
          const remaining = Number(item.remainingQuantity ?? item.quantity) || 0;
          const requested = Number(item.receivedQuantity ?? item.quantity) || 0;
          this.poQuantity = Math.min(requested, remaining);
          this.poPrice = item.price;
        } else {
          // fallback to DOM lookups if item not present
          this.poQuantity = document.getElementById('quantity'+itemId)?.value;
          this.poPrice = document.getElementById('price'+itemId)?.value;
        }
        this.poCondition = document.getElementById('condition'+itemId)?.value;
        this.poComment = document.getElementById('comment'+itemId)?.value;
        this.poProductId = productId;
        this.poItemId = itemId;
        this.isVisiblePO = true;
      },
      async postCompleteItem () {
        const currentItemId = this.poItemId;
        this.isCompletingItem = currentItemId;
        // Close modal immediately on click per UX requirement
        this.isVisiblePO = false;
        
        // Safety timeout: reset completing state after 60 seconds to prevent permanent lock
        const timeoutId = setTimeout(() => {
          console.warn('Item completion timeout - resetting isCompletingItem');
          this.isCompletingItem = null;
        }, 60000);
        
        try {
          // If PO is selected and batch hasn't been created yet, create batch first
          if (this.purchaseId && !this.batchId) {
            console.log('First item completion with PO selected. Creating batch first...');
            await this.postBatch();
            if (!this.batchId) {
              console.error('Batch creation failed, aborting item completion');
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to create batch. Please try again.'
              });
              return;
            }
          }

          // ensure we do not post more than remaining quantity
          const poItem = (this.purchase?.PurchaseProduct || []).find(p => p.id === this.poItemId) || null;
          const maxAllowed = Number(poItem?.remainingQuantity ?? poItem?.quantity ?? 0) || 0;
          const qtyToSend = Math.min(Number(this.poQuantity) || 0, maxAllowed);

          const payload = {
            productId: this.poProductId,
            batchId: this.batchId,
            purchaseId: this.purchaseId, // send parent purchase id (fixed)
            purchaseProductId: this.poItemId, // include purchaseProduct id as reference
            quantity: qtyToSend,
            // backend expects price as a string
            price: String(this.poPrice),
            condition: this.poCondition,
            comment: this.poComment,
            warehouseId: this.poWarehouseId,
            sectionId: this.poSectionId,
          };
          console.log('Posting batch item (complete) payload', payload);
          const requestOptions = { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer '+this.token }, body: JSON.stringify(payload) };
          const res = await fetch(process.env.VUE_APP_URL+'/batches/items', requestOptions)
          const data = await res.json()
          if(data.status == true){
              this.completedItems.push(this.poItemId);
              this.isVisiblePO = false;
              console.log('Item completed successfully, completedItems:', this.completedItems);
          } else {
              console.error('Backend returned error:', data.message);
              Swal.fire({
                  icon: 'error',
                  title: 'Batch Item not created',
                  text: data.message
              })
          }
        } catch (error) {
          console.error('Error completing item:', error)
          Swal.fire({
            icon: 'error',
            title: 'Error completing item',
            text: error.response?.data?.message || 'An error occurred'
          })
        } finally {
          clearTimeout(timeoutId);
          // Use a small timeout to ensure Vue state is settled before resetting
          await this.$nextTick();
          this.isCompletingItem = null;
          console.log('isCompletingItem reset to null, buttons should be re-enabled');
        }
      },
      onReceivedQtyChange(item) {
        this.recalcAmount(item);
      },

      recalcAmount(item) {
        const unit = Number(item.unitPrice ?? item.price) || 0;
        const qty = Number(item.receivedQuantity) || 0;
        item.receivedAmount = parseFloat((unit * qty).toFixed(2));
      },
      isItemCompleted(itemId) {
        return this.completedItems.includes(itemId);
      }
  },
  watch:{
      productId(newValue){
        const parsedValue = parseInt(newValue)
        let productObj = this.products.find(i => i.id === parsedValue);
        this.itemUnit = productObj?.unit?.unit
        this.itemNog = productObj?.Category?.category
        this.itemSubUnit = "None"
      },
      warehouseId(newValue){
          let obj = this.warehouses.find(i => i.id === newValue);
          this.sections = obj.sections
          this.sectionId = ""
      },
      poWarehouseId(newValue){
          let obj = this.warehouses.find(i => i.id === newValue);
          this.sections = obj.sections
          this.poSectionId = ""
      },
      isGuardian(newValue){
        if(newValue)
          this.displayGuardian = "block"
        else
          this.displayGuardian = "none"
        
      },
      isInternal(newValue) {
        if(newValue){
          this.DriverDisplay = "block"
          this.SupplierDisplay = "none"
        } else{
          this.DriverDisplay = "none"
          this.SupplierDisplay = "block"
          
          // Auto-select EXTERNAL tag when internal delivery is toggled to No
          console.log('isInternal watcher: External delivery selected, looking for EXTERNAL tag')
          const externalTag = this.tags?.find(t => t.tag?.toUpperCase() === 'EXTERNAL')
          if (externalTag) {
            console.log('Found EXTERNAL tag with id:', externalTag.id)
            this.tagId = externalTag.id
          } else {
            console.log('EXTERNAL tag not found in tags array:', this.tags)
          }
        }
      },
      purchaseId(newValue) {
        console.log('purchaseId watcher triggered with value:', newValue)
        if (!newValue) {
          this.project = ""
          this.supplierId = null
          this.purchase = null
          this.purchaseItemsReady = false
          return
        }
        // First try: check if project data is already in purchasenos
        console.log('Looking for purchase in purchasenos:', this.purchasenos)
        const selectedPurchase = this.purchasenos?.find(p => {
          console.log('Checking purchase:', p.id, 'against newValue:', newValue)
          return p.id === newValue
        })
        console.log('Selected purchase from purchasenos:', selectedPurchase)
        if (selectedPurchase) {
          console.log('Selected purchase full object:', selectedPurchase)
          
          // Set project
          if (selectedPurchase.project) {
            console.log('Project found in purchasenos:', selectedPurchase.project)
            this.project = selectedPurchase.project
          }
          
          // Set supplier
          if (selectedPurchase.supplierId) {
            console.log('Supplier ID found in purchasenos:', selectedPurchase.supplierId)
            this.supplierId = selectedPurchase.supplierId
          }
          
          // Toggle internal delivery to No (false) when PO is selected
          this.isInternal = false
          console.log('Internal delivery set to false')
        }
        // Always call setupPurchase to fetch full details and PO items
        console.log('Calling setupPurchase to fetch full purchase data and items...')
        this.setupPurchase()
      },
      purchase(newValue) {
        // Auto-select project and supplier when purchase data is loaded
        console.log('Purchase watcher triggered, new purchase:', newValue)
        if (newValue) {
          console.log('Purchase object keys:', Object.keys(newValue))
          console.log('Purchase project value:', newValue.project)
          console.log('Purchase supplierId value:', newValue.supplierId)
          
          // Set project (if not already set from purchasenos)
          if (newValue.project && !this.project) {
            console.log('Setting project to:', newValue.project)
            this.project = newValue.project
            console.log('Project was set, current project value:', this.project)
          }
          
          // Set supplier (if not already set from purchasenos)
          if (newValue.supplierId && !this.supplierId) {
            console.log('Setting supplier to:', newValue.supplierId)
            this.supplierId = newValue.supplierId
            console.log('Supplier was set, current supplier value:', this.supplierId)
          }
        }
      },
      purchasenos(newValue) {
        // Reset purchase options when purchasenos list changes
        console.log('purchasenos watcher triggered with value:', newValue)
        this.setupPurchaseOptions()
      },
      projects(newValue) {
        // Reset project options when projects list changes
        console.log('projects watcher triggered with value:', newValue)
        this.setupProjectOptions()
      }
  }
}
</script>

<style lang="scss" scoped>
  $text-color: #000000;
  $primary: #d2d2d2;
  $green: #000000;
  $white: #ffffff;

  /* Button text: capitalize, font-size 10px */
  .btn,
  .btn-style,
  button {
    text-transform: capitalize !important;
    font-size: 10px !important;
  }

  select{
    /* inline SVG */
    background: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20448%22%20enable-background%3D%22new%200%200%20256%20448%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.arrow%7Bfill%3A%23424242%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22arrow%22%20d%3D%22M255.9%20168c0-4.2-1.6-7.9-4.8-11.2-3.2-3.2-6.9-4.8-11.2-4.8H16c-4.2%200-7.9%201.6-11.2%204.8S0%20163.8%200%20168c0%204.4%201.6%208.2%204.8%2011.4l112%20112c3.1%203.1%206.8%204.6%2011.2%204.6%204.4%200%208.2-1.5%2011.4-4.6l112-112c3-3.2%204.5-7%204.5-11.4z%22%2F%3E%3C%2Fsvg%3E%0A"), #fff;
    background-position: right 10px center;
    background-repeat: no-repeat;
    background-size: auto 50%;
    border-radius: 3px;
    height: 40px;
    border: 1px solid #b4c7e7 !important;
    padding: 5px 30px 5px 10px;
    // disable default appearance
    outline: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    &::-ms-expand { display: none };
    &.full{
      width: 100%;
    }
    &:focus, &:hover{
      background: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20256%20448%22%20enable-background%3D%22new%200%200%20256%20448%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E.arrow%7Bfill%3A%23424242%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22arrow%22%20d%3D%22M255.9%20168c0-4.2-1.6-7.9-4.8-11.2-3.2-3.2-6.9-4.8-11.2-4.8H16c-4.2%200-7.9%201.6-11.2%204.8S0%20163.8%200%20168c0%204.4%201.6%208.2%204.8%2011.4l112%20112c3.1%203.1%206.8%204.6%2011.2%204.6%204.4%200%208.2-1.5%2011.4-4.6l112-112c3-3.2%204.5-7%204.5-11.4z%22%2F%3E%3C%2Fsvg%3E%0A"), #fff;
      border: 1px solid $text-color;
      background-position: right 10px center;
      background-repeat: no-repeat;
      background-size: auto 50%;
    }
  }

  .check-button{
        display: flex;
        align-items: center;
        gap: 10px;
      }
      .form-group{
        .components-button {
          display: flex;
          align-items: center;
          justify-content: left;
          span.switcher {
            position: relative;
            width: 156px;
            height: 56px;
            border-radius: 10px;
            input {
              appearance: none;
              position: relative;
              width: 130px;
              height: 40px;
              border-radius: 3px;
              border-color: #d2d2d2 !important;
              background: $primary;
              outline: none;
              font-family: 'Oswald', sans-serif;
              &:before, &:after {
                z-index: 2;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                color: $white;
              }
              &:before {
                content: 'Yes';
                left: 13px;
                font-weight: 600;
                font-size: 13px;
                line-height: 33px;
                color: #FFFFFF;
              }
              &:after {
                content: 'No';
                right: 13px;
                font-weight: 600;
                font-size: 17px;
                line-height: 33px;
                color: #FFFFFF;
              }
            }
            label {
              z-index: 1;
              position: absolute;
              width: 55px;
              height: 32px;
              margin: 0;
              top: 4px;
              left: 71px !important;
              border-radius: 3px;
            }
            &.switcher-1, &.switcher-2 {
              input {
                transition: .25s -.1s;
                &:checked {
                  background: $primary;
                  &:before {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  &:after {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  & + label {
                    left: 4px !important;
                    background: $green;
                    transition: left .5s, right .4s .2s;
                    height: 30px !important;
                  }
                }
                &:not(:checked) {
                  background: $primary;
                  transition: background .5s -.1s;
                  &:before {
                    color: #ffffff;
                    transition: color .5s;
                  }
                  &:after {
                    color: $white;
                    transition: color .5s .2s;
                  }
                  & + label {
                    left: 100px;
                    right: 10px;
                    background: $green;
                    height: 30px !important;
                    transition: left .4s .2s, right .5s, background .35s -.1s;
                  }
                }
              }
            }
          }
        }
      }

  
  .fulfilled-row {
    background-color: #f3f4f6 !important;
    color: #6c757d;
    opacity: 0.6;
    pointer-events: none;
    cursor: not-allowed;
  }
  .fulfilled-row td {
    background-color: transparent !important;
    color: #6c757d !important;
  }

  /* Style Select2 to match regular selects */
  :deep(.select2-container--default .select2-selection--single) {
    height: 32px;
    border: 1px solid #cedbf3 !important;
    border-radius: 3px;
    background-color: #fff;
    padding: 0;
    &.full{
      width: 100%;
    }
    outline: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    &::-ms-expand { display: none };
    
  }


  :deep(.select2-container--default .select2-selection--single .select2-selection__rendered) {
    line-height: 32px;
    padding-left: 10px;
    color: #000;
  }

  :deep(.select2-container--default .select2-selection--single .select2-selection__arrow) {
    height: 32px;
    width: 30px;
    right: 3px;
    top: 0;
  }

  :deep(.select2-container--default .select2-selection--single .select2-selection__arrow b) {
    border-color: #424242 transparent transparent transparent;
    border-width: 8px 6px 0 6px;
    top: 50%;
    margin-top: -4px;
  }

  :deep(.select2-container--open .select2-dropdown) {
    border: none;
    border-radius: 3px;
  }

  :deep(.select2-container--default .select2-results__option--highlighted[aria-selected]) {
    background-color: #d9e5fa;
  }

  :deep(.select2-search__field) {
    border: none !important;
    border-radius: 3px;
    padding: 5px 10px;
    height: 32px;
  }

  /* Full width for Select2 */
  .select2 {
    width: 100% !important;
  }

  :deep(.select2-container) {
    width: 100% !important;
  }

  /* Disabled state for Select2 */
  :deep(.select2-container.select2-container--disabled .select2-selection) {
    background-color: #e9ecef;
    cursor: not-allowed;
    opacity: 0.65;
    border: none !important;
  }

  :deep(.select2-container--disabled .select2-selection__rendered) {
    color: #6c757d;
  }

  :deep(.select2-container.select2-container--disabled) {
    pointer-events: none;
  }

  /* Disabled Select2 in Vue - handle v-bind:disabled */
  .select2[disabled] :deep(.select2-container .select2-selection) {
    background-color: #e9ecef;
    opacity: 0.65;
    cursor: not-allowed;
    border: none !important;
  }

  .select2-disabled :deep(.select2-selection) {
    background-color: #e9ecef !important;
    opacity: 0.65 !important;
    cursor: not-allowed !important;
    border: none !important;
  }

  .select2-disabled :deep(.select2-selection__rendered) {
    color: #6c757d !important;
  }

  .select2-disabled :deep(.select2-selection__arrow) {
    opacity: 0.5;
  }

  /* Reduce label to input spacing for form groups */
  .form-group label {
    margin-bottom: 0px !important;
  }

  /* Skeleton Loader Animation */
  @keyframes skeleton-loading {
    0% {
      background-color: #e0e0e0;
    }
    50% {
      background-color: #f0f0f0;
    }
    100% {
      background-color: #e0e0e0;
    }
  }

  .skeleton-loader {
    padding: 12px;
    background-color: #fff;
    border-radius: 3px;
  }

  .skeleton-header,
  .skeleton-row {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
    align-items: center;
  }

  .skeleton-header {
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
  }

  .skeleton-cell {
    height: 16px;
    background-color: #e0e0e0;
    border-radius: 2px;
    animation: skeleton-loading 1.5s infinite ease-in-out;
  }

  .skeleton-header .skeleton-cell {
    height: 18px;
    font-weight: 600;
  }

  /* Service Modal Styling */
  .svc-modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,.45);
    z-index: 1200;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .svc-modal-box {
    background: #fff;
    border-radius: 8px;
    width: 100%;
    max-width: 560px;
    box-shadow: 0 8px 32px rgba(0,0,0,.18);
    display: flex;
    flex-direction: column;
  }

  .svc-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 18px;
    border-bottom: 1px solid #e9ecef;
  }

  .btn-close-plain {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #6c757d;
    line-height: 1;
  }

  .svc-modal-body {
    padding: 16px 18px;
    overflow-y: auto;
  }

  .svc-modal-footer {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 11px 18px;
    border-top: 1px solid #e9ecef;
  }

  /* Input Skeleton Loader */
  .skeleton-input {
    height: 38px;
    background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    border-radius: 3px;
  }

  /* Disabled button states */
  button:disabled {
    opacity: 0.65 !important;
    cursor: not-allowed !important;
    pointer-events: none !important;
  }

  .btn-close-plain:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  /* Horizontal Loader Animation */
  @keyframes horizontal-loader {
    0% {
      width: 0%;
      background-position: 0% 50%;
    }
    50% {
      width: 100%;
      background-position: 100% 50%;
    }
    100% {
      width: 0%;
      background-position: 200% 50%;
    }
  }

  .complete-item-btn {
    position: relative;
    overflow: hidden;
    min-width: 150px;
  }

  .loader-text {
    position: relative;
    z-index: 1;
    display: inline-block;
  }

  .horizontal-loader {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 0%;
    background: linear-gradient(90deg, rgba(255,255,255,0.3), rgba(255,255,255,0.8), rgba(255,255,255,0.3));
    background-size: 200% 100%;
    animation: horizontal-loader 1.5s ease-in-out infinite;
    border-radius: inherit;
    z-index: 0;
  }

  /* Disabled select styling */
  select:disabled {
    background-color: #e9ecef;
    color: #6c757d;
    opacity: 0.65;
  }
</style>